import {motion} from 'framer-motion';

function BrandStatement() {
  return (
    <section className="bg-[#F7F2EA] py-28 md:py-40 px-6 md:px-12 lg:px-20">
      <div className="max-w-4xl mx-auto text-center">
        <motion.p initial={{opacity: 0}} whileInView={{opacity: 1}} viewport={{once: true}} className="eyebrow eyebrow-center mb-10" style={{color: '#B87333'}}>
          A philosophy
        </motion.p>
        <motion.h2 initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.7}} className="font-display text-[clamp(32px,5vw,64px)] leading-[1.15] text-[#1F1B17] font-light">
          We believe a wardrobe should feel like a <em className="italic text-[#1F3D2E]">quiet conversation</em> — between the woman,the cloth and the occasion. Nothing loud. Nothing borrowed. Only pieces that feel <em className="italic text-[#1F3D2E]">deliberately yours.</em>
        </motion.h2>
        <motion.div initial={{scaleX: 0}} whileInView={{scaleX: 1}} viewport={{once: true}} transition={{duration: 0.8}} className="mt-12 mx-auto w-24 h-px bg-[#B87333]" />
      </div>
    </section>
  );
}

export default BrandStatement;
